// extracted by mini-css-extract-plugin
module.exports = {"sold":"Hall_sold__12Uww"};